import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

import CarouselCard from '../CarouselCard/CarouselCard';

function VeloComplianceCard() {
  const { businessEntityUuid } = useBusinessEntity();
  const href = `/guide/company/${businessEntityUuid}?topic=questions-about-compliance`;

  return (
    <CarouselCard
      imageSrc="/s2/raster/desk-document-reading-carousel.png"
      imageAltId="dashboard.carousel.card.veloCompliance.imageAlt"
      titleId="dashboard.carousel.card.veloCompliance.title"
      subtitleId="dashboard.carousel.card.veloCompliance.subTitle"
      href={href}
      elementName="carousel_velo_compliance_link"
    />
  );
}

export default VeloComplianceCard;
